import { App } from 'vue'
import NumberInput from './LpNumberInput.vue'

NumberInput.install = (Vue: App) => {
  Vue.component(NumberInput.name, NumberInput)
}

export default NumberInput
